module.exports = __webpack_public_path__ + "static/media/WaterDropIcon.fe9ecd84.svg";